import { clearMoneyMask } from 'helpers/functions';
import { EChargeType } from 'v2/interfaces/product';

export const HIGH_TICKET_MIN_PRICE = 10000;

type OfferPrice = {
  value: number;
  currency_code: string;
};

type ProductSaleFields = {
  charge_type: string;
  price?: string | number;
  recurring_value?: string | number;
  accepted_highticket_terms?: boolean;
};

function getNumericPrice(value: string | number | undefined): number {
  return Number(clearMoneyMask(value ?? 0)) || 0;
}

export function isHighTicketValue(value: number | undefined): boolean {
  return (value ?? 0) >= HIGH_TICKET_MIN_PRICE;
}

export function getProductSaleValue(product: ProductSaleFields): number {
  if (product.charge_type === EChargeType.SUBSCRIPTION) {
    return getNumericPrice(product.recurring_value);
  }

  if (product.charge_type === EChargeType.SINGLE) {
    return getNumericPrice(product.price);
  }

  return 0;
}

export function isHighTicketProduct(product: ProductSaleFields): boolean {
  return isHighTicketValue(getProductSaleValue(product));
}

export function shouldDisplayHighTicketTerms(product: ProductSaleFields): boolean {
  return isHighTicketProduct(product) && !product.accepted_highticket_terms;
}

export function isHighTicketOffer(prices: OfferPrice[]): boolean {
  const brlPrice = prices.find(price => price.currency_code === 'BRL')?.value;
  return isHighTicketValue(brlPrice);
}
